import { render, staticRenderFns } from "./LegendTipModal.vue?vue&type=template&id=5d46717a&scoped=true&"
import script from "./LegendTipModal.vue?vue&type=script&lang=js&"
export * from "./LegendTipModal.vue?vue&type=script&lang=js&"
import style0 from "./LegendTipModal.vue?vue&type=style&index=0&id=5d46717a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d46717a",
  null
  
)

export default component.exports